export default "__VITE_ASSET__DCchSHyA__"